import { useState, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import Web3 from "web3";
import UiButton from "../../components/button";
import Loader from "../loader";

import "react-toastify/dist/ReactToastify.css";
import TextInput from "../../components/textinput/TextInput";
import ERC20ABI from "../../utils/abi/ERC20.json";
import { toast } from "react-toastify";
import {
  FailureToast,
  SuccessToast,
  ToastOptions,
} from "../../utils/constants";
import { useNetworkOptions } from "../../context/contractDataLoaderService";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../utils/helpers/networks";
import { providers } from "ethers";
import { useGlobal } from "../../context/globalContext";
import { Security } from "@verified-network/verified-sdk";
import { getAllVerifiedCashBalances } from "../../utils/helpers";

function RefundsModal(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;
  const [burnAmount, setBurnAmount] = useState();
  const [loading, setLoading] = useState(false);
  const [changeContent, setChangeContent] = useState(false);
  const modalContent = useRef(null);
  const { data: networkOptions } = useNetworkOptions();

  const scheduleSnapshot = async () => {
    if (
      web3 &&
      signer &&
      props.data?.securityAddress &&
      props.data?.transferor
    ) {
      setLoading(true);
      const securityTokenContract = new Security(
        signer,
        props.data.securityAddress,
      );
      const amount = web3.utils.toWei(burnAmount, "ether");

      let paymentToken;

      if (
        verifiedWalletDetails &&
        Object?.keys(verifiedWalletDetails)?.length > 0
      ) {
        const cashTokens = await getAllVerifiedCashBalances(
          chainId,
          web3,
          account,
        );

        if (!cashTokens || cashTokens?.length === 0) {
          setLoading(false);
          toast.error(
            "No valid Cash Token on this network. Change network and try again.",
            ToastOptions,
          );

          return;
        }
        paymentToken = cashTokens[0];
        const txQuote = await securityTokenContract._getMeeQuote(
          cashTokens[0]?.address,
          "burn",
          [props.data.transferor, amount?.toString()],
        );

        if (
          Number(cashTokens[0]?.balance) === 0 ||
          Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
        ) {
          setLoading(false);
          toast.error(
            `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
            ToastOptions,
          );

          return;
        }
      }

      try {
        await securityTokenContract
          .burn(
            props.data.transferor,
            amount?.toString(),
            paymentToken?.address
              ? {
                  paymentToken: paymentToken?.address,
                  apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                }
              : {},
          )

          .then((res) => {
            setLoading(false);
            if (res?.status === 0) {
              setLoading(false);
              toast.success(SuccessToast(), ToastOptions);
              setChangeContent(true);
              modalContent.current.innerHTML = "";
            } else {
              setLoading(false);
              toast.error(FailureToast(), ToastOptions);
            }
          })
          .catch((err) => {
            setLoading(false);
            toast.error(FailureToast(), ToastOptions);
          });
      } catch (err) {
        let error = { err };
        setLoading(false);
        toast.error(FailureToast(), ToastOptions);
      }
    }
  };
  return (
    <>
      {loading ? <Loader /> : null}
      {changeContent && (
        <UiButton
          onClick={() => {
            props.onModalHide();
          }}
          buttonVariant="primary"
          buttonClass="SignUpButton flex-1 ml-0"
          buttonText="Click to close this form&nbsp;&rarr;"
          type="submit"
        />
      )}
      <div className="d-grid gap-2" ref={modalContent}>
        <Row className="ml-1 align-items-center">
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Amount</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Decimals supported"
                fieldType="number"
                required
                value={burnAmount}
                onChange={(e) => setBurnAmount(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="mx-0 my-2 pl-0 width-100 align-items-center">
            <Col className="pl-0">
              <UiButton
                onClick={() => {
                  scheduleSnapshot();
                }}
                buttonVariant="primary"
                buttonClass="SignUpButton flex-1 ml-0"
                buttonText="Burn"
                type="submit"
              />
            </Col>
          </Row>
        </Row>
      </div>
    </>
  );
}

export function BurnInvestorSecurity(props) {
  return <RefundsModal {...props} />;
}
